class Debug {
  #objects: Record<string, unknown> = {};

  setObject(name: string, object: unknown): void {
    this.#objects[name] = object;
  }
}

export const debug = new Debug();

declare global {
  interface Window {
    __DEBUG__: Debug;
  }
}

window.__DEBUG__ = debug;
